module.exports = __webpack_public_path__ + "assets/media/day3.2c68f724.mp3";